// extracted by mini-css-extract-plugin
export default {"floating":"Floating_floating__fpue6","Floating":"Floating_Floating__qdj2a","shrinking":"Floating_shrinking__4j21h","Shrinking":"Floating_Shrinking__zLdZB"};